"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeRAGStatus = void 0;
var KnowledgeRAGStatus;
(function (KnowledgeRAGStatus) {
    KnowledgeRAGStatus["PENDING"] = "pending";
    KnowledgeRAGStatus["PROCESSING"] = "processing";
    KnowledgeRAGStatus["COMPLETED"] = "completed";
    KnowledgeRAGStatus["FAILED"] = "failed";
    KnowledgeRAGStatus["NOT_INDEXED"] = "not_indexed";
})(KnowledgeRAGStatus || (exports.KnowledgeRAGStatus = KnowledgeRAGStatus = {}));
